module.exports = __webpack_public_path__ + "img/wave_top_home.b468579f.svg";